import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Paginated } from './paginated';
import type { DocumentData } from '@/types/api';

type DocFilters = { q?: string; category?: string; page?: number };

/** Read-only document library for the portal, scoped + permission-gated. */
export function usePortalDocuments(filters: DocFilters = {}) {
  return useQuery({
    queryKey: ['portal-documents', filters],
    queryFn: async (): Promise<Paginated<DocumentData>> => {
      const { data } = await api.get<Paginated<DocumentData>>('/v1/portal/documents', { params: filters });
      return data;
    },
  });
}
